import { render } from "./index.vue?vue&type=template&id=95a15b08&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=95a15b08&lang=scss&scoped=true"

import exportComponent from "/Users/zuzhiming/工作/xlc-khgw/Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95a15b08"]])

export default __exports__